// Copyright (c) StrangeBee 2023

import useLocalStorage, { LocalStorageKeys } from '@Hooks/useLocalStorage';
import React, { useState, useEffect } from 'react';

export interface StorageTimeline {
    [key: string]: Record<string, any>;
}

interface UseStorageTimelineOutput {
    timelineStorage: StorageTimeline;
    setTimelineStorage: React.Dispatch<React.SetStateAction<StorageTimeline>>;
}

export const useStorageTimeline = (): UseStorageTimelineOutput => {
    const { storage, setStorage } = useLocalStorage<StorageTimeline>({
        key: LocalStorageKeys.TIMELINE,
        initialValue: {},
    });

    const [timelineStorage, setTimelineStorage] = useState<StorageTimeline>(storage);

    useEffect(() => {
        setStorage((state) => ({ ...state, ...timelineStorage }));
    }, [timelineStorage, setTimelineStorage]); //eslint-disable-line

    return { timelineStorage, setTimelineStorage };
};
